'use client'

import { AppStoreDownloadButton } from '@/components/app-store-download-button'
import { Motion } from '@/components/motion'
import { PlayStoreDownloadButton } from '@/components/play-store-download-button'
import { cn } from '@/utils/styles/cn'

interface IHomeDownloadButtonsProps {
    className?: string
}

export const HomeDownloadButtons = ({ className }: IHomeDownloadButtonsProps) => {
    return (
        <div className={cn('flex flex-row gap-2 mb-4 md:mb-0', className)}>
            <Motion baseDelay={0.8} y={40}>
                <AppStoreDownloadButton />
            </Motion>

            <Motion baseDelay={1} y={40}>
                <PlayStoreDownloadButton />
            </Motion>
        </div>
    )
}
